
const InformationTitleType = Symbol();

export class InformationTitle {
    [InformationTitleType]: any;
    readonly value: string;

    private constructor(informationTitle: string) {
        this.value = informationTitle;
    }

    static isInvalidSize(title: string): boolean {
        return title.length < 1 || title.length > 50;
    }

    static messageInvalidSize(label: string): string {
        return `${label}は1文字以上50文字以下で入力してください。`;
    }

    static fromString(informationTitle: string): InformationTitle {
        return new InformationTitle(informationTitle);
    }
}
